import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './components/Login.jsx';
import ChangePassword from './components/ChangePassword.jsx';
import Dashboard from './components/Dashboard.jsx';
import theme from './theme';

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem('token') ? true : false;
  const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    } else if (mustChangePassword) {
      navigate('/change-password');
    }
  }, [isAuthenticated, mustChangePassword, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (mustChangePassword) {
    return <Navigate to="/change-password" />;
  }

  return children;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('token') ? true : false
  );

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('tenant');
    localStorage.removeItem('mustChangePassword');
    setIsAuthenticated(false);
  };

  const handlePasswordChanged = () => {
    // Password changed successfully, user can now access dashboard
    localStorage.removeItem('mustChangePassword');
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ?
              <Navigate to="/dashboard" /> :
              <Login onLogin={handleLogin} />
            }
          />
          <Route
            path="/change-password"
            element={
              !isAuthenticated ?
              <Navigate to="/login" /> :
              <ChangePassword onPasswordChanged={handlePasswordChanged} />
            }
          />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard onLogout={handleLogout} />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
